/**
 * static/js/utils/copy.js
 *
 * One-click "copy to clipboard" for any button carrying a data-copy attribute.
 * data-copy holds a CSS selector pointing at the element whose value/text to copy
 * (an <input>/<textarea> uses .value, anything else uses textContent). On success
 * the button's label is swapped to a "Copied" confirmation for ~2s, then restored.
 *
 * Auto-wires every [data-copy] on the page at load, so templates need no per-page JS.
 *
 * Usage:
 *   <input id="share-link" value="https://journalist.net/?ref=REUTERS" readonly>
 *   <button data-copy="#share-link">Copy link</button>
 */
(function (window, document) {
  'use strict';

  var RESET_MS = 2000;
  var DONE_HTML = '<iconify-icon icon="f7:checkmark-alt"></iconify-icon> Copied';

  function readValue(el) {
    if (!el) return '';
    return ('value' in el && el.value !== undefined) ? el.value : (el.textContent || '');
  }

  function execCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    var ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  }

  function writeClipboard(text) {
    // Prefer the async Clipboard API, but fall back to execCommand when it is
    // absent OR rejects (non-secure context, permission denied, older browsers).
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        if (!execCopy(text)) throw new Error('copy failed');
      });
    }
    return execCopy(text) ? Promise.resolve() : Promise.reject(new Error('copy failed'));
  }

  function flashDone(btn) {
    if (btn.__jn_copy_resetting) return;
    btn.__jn_copy_resetting = true;
    var original = btn.innerHTML;
    btn.innerHTML = DONE_HTML;
    window.setTimeout(function () {
      btn.innerHTML = original;
      btn.__jn_copy_resetting = false;
    }, RESET_MS);
  }

  function onClick(e) {
    var btn = e.currentTarget;
    var target = document.querySelector(btn.getAttribute('data-copy'));
    var text = readValue(target);
    if (!text) return;
    writeClipboard(text).then(function () { flashDone(btn); });
  }

  function wire(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-copy]');
    buttons.forEach(function (btn) {
      if (btn.__jn_copy_wired) return;
      btn.__jn_copy_wired = true;
      btn.addEventListener('click', onClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); });
  } else {
    wire();
  }

  window.JN = window.JN || {};
  window.JN.copy = { wire: wire };
})(window, document);
